"use client"

import { Info } from "lucide-react"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { AUTO_APPROVE_AFTER_PENDING_DAYS, isAutoApproveCountdownLabel } from "@/lib/connection-display-utils"
interface AutoApproveStatusHintProps {
  statusDate: string
}

export function AutoApproveStatusHint({ statusDate }: AutoApproveStatusHintProps) {
  if (!isAutoApproveCountdownLabel(statusDate)) {
    return <>{statusDate}</>
  }
  return (
    <span className="inline-flex max-w-full items-center justify-center gap-0.5">
      <span>{statusDate}</span>
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="inline-flex shrink-0 rounded-full text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            aria-label="About automatic approval"
          >
            <Info className="h-3 w-3" strokeWidth={2.25} />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-80 text-sm" align="center" side="top">
          <p className="text-muted-foreground leading-relaxed">
            Automatic approval is scheduled{" "}
            <span className="font-medium text-foreground">{AUTO_APPROVE_AFTER_PENDING_DAYS} calendar days</span> after
            the date this connection entered{" "}
            <span className="font-medium text-foreground">Pending Approval</span>.
          </p>
        </PopoverContent>
      </Popover>
    </span>
  )
}
